@if (shouldShowBanner()) {
  <div class="location-banner" role="status" aria-live="polite">
    <ac-icon iconKey="hr:info" [size]="20" />
    <span class="banner-copy">{{ copy()?.message }}</span>
    <button mat-flat-button class="ac-neutral cta-btn" type="button" [loading]="verifying()" (click)="onCtaClick()">
      {{ copy()?.cta }}
    </button>
  </div>
}
